import { Pipe, PipeTransform } from '@angular/core';
import { concat, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { EditTemplateService } from 'app/main/pages/edit-template/edit-template.service';

interface CountryResult {
  countryCode: string | null;
  calling_code: string | null;
}
const DEFAULT_COUNTRY_RESULT: CountryResult = { countryCode: CountryISO.Sweden, calling_code: '+46' };
@Pipe({
  name: 'ipToCountry',
})
export class IpToCountryPipe implements PipeTransform {
  constructor(private editTemplateService: EditTemplateService) { }
  
  transform(defaultCountry: string | null): Observable<CountryResult> {
    if (defaultCountry) {
      // Default country already known
      return of({ countryCode: defaultCountry, calling_code: null });
    }
    // Fallback to IP lookup
    return concat(
      // Step 1️⃣: Emit default instantly (removes flicker)
      of(DEFAULT_COUNTRY_RESULT),
      this.editTemplateService.getCountry().pipe(
        map((data: { country_code: string; calling_code: string }) => {
          const countryCode = data.country_code?.toUpperCase() as string | undefined;

          if (countryCode) {
            const callingCode = data.calling_code ? `+${data.calling_code}` : null;
            return { countryCode, calling_code: callingCode };
          }

          // Fallback to Sweden if invalid or missing
          return DEFAULT_COUNTRY_RESULT;
        }),
        catchError(() => of(DEFAULT_COUNTRY_RESULT))
      ));
  }
}
